<div class="address">
  <p class="fs-xs ion-text-uppercase">
    {{ address().company }}
  </p>
  <p class="fs-sm">{{ address().street }}.</p>
  @if (address().extraLine) {
    <p>{{ address().extraLine }}</p>
  }
  <p class="fs-sm">{{ address().postalCode }} {{ address().city }}</p>
  <p class="fs-sm ion-text-uppercase">
    <strong>
      @if (address().countryCode) {
        ({{ address().countryCode }})
        @if (address().countryCode) {
          {{ `states.${address().countryCode}${address().stateCode}` | translate }}
        }
      }
    </strong>
  </p>
</div>
